/**
 * Service d'authentification admin avec backend PHP sécurisé
 */

export interface LoginResponse {
  success: boolean;
  message?: string;
  username?: string;
  token?: string;
  error?: string;
}

export interface AuthCheckResponse {
  success: boolean;
  authenticated: boolean;
  username?: string;
  login_time?: number;
}

export class AuthService {
  /**
   * Authentifier un utilisateur admin
   */
  static async login(username: string, password: string): Promise<LoginResponse> {
    try {
      const response = await fetch('/admin-login.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include', // Important pour les cookies de session
        body: JSON.stringify({ username, password }),
      });

      const data = await response.json();
      
      if (!response.ok) {
        return {
          success: false,
          error: data.error || 'Erreur lors de l\'authentification'
        };
      }

      return data;
    } catch (error) {
      console.error('Erreur lors de la connexion:', error);
      return {
        success: false,
        error: error instanceof Error ? error.message : 'Erreur de connexion au serveur'
      };
    }
  }

  /**
   * Vérifier si l'utilisateur est authentifié
   */
  static async checkAuth(): Promise<AuthCheckResponse> {
    try {
      const response = await fetch('/admin-check-auth.php', {
        method: 'GET',
        credentials: 'include', // Important pour les cookies de session
      });

      if (!response.ok) {
        return {
          success: false,
          authenticated: false
        };
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Erreur lors de la vérification de l\'authentification:', error);
      return {
        success: false,
        authenticated: false
      };
    }
  }

  /**
   * Déconnecter l'utilisateur
   */
  static async logout(): Promise<{ success: boolean; message?: string; error?: string }> {
    try {
      const response = await fetch('/admin-logout.php', {
        method: 'POST',
        credentials: 'include', // Important pour les cookies de session
      });

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Erreur lors de la déconnexion:', error);
      return {
        success: false,
        error: error instanceof Error ? error.message : 'Erreur de déconnexion'
      };
    }
  }
}


